import React, { useEffect, useState } from "react";
import { Link } from "@quintype/components";
import { PublishAndReadTime } from "../../../atoms/PublishAndReadTime";
import { HeroImage } from "../../../atoms/HeroImage";
import { getStoryHeadline, isExternalStory } from "../../../utils/story";
import Headline from "../../../atoms/Headline";
import { getGoldArticle } from "../../../../../api/utils";
import "./middle-section.m.css";

const StoryCard = ({ story }) => {
  const externalStoryUrl = isExternalStory(story);
  const href = externalStoryUrl || `/${story?.slug}`;
  const target = externalStoryUrl ? "_blank" : "_self";
  const type = "secondary";
  return (
    <Link href={href} target={target} styleName="card-wrapper">
      <div styleName={`${type}-story-container`}>
        <StoryTextContent story={story} type={type} isSubHeadlineToShow={false} showLabel={true} />
        <div styleName={`${type}-story-image-container`}>
          <HeroImage
            story={story}
            widths={[110]}
            aspectRatio={[[4, 3]]}
            headline={getStoryHeadline(story)}
            iconSizes={{ width: 48, height: 48 }}
          />
        </div>
      </div>
    </Link>
  );
};

const StoryTextContent = ({ story, type }) => {
  const headline = getStoryHeadline(story);
  const label = "UPDATE";
  return (
    <div styleName={`${type}-story-box`}>
      <div>
        <span styleName="labelClassName">{label}</span>
      </div>
      {headline && <Headline headline={headline} styleName={`${type}-headline`} />}
      <PublishAndReadTime showReadTime={true} showTimestamp={true} story={story} />
    </div>
  );
};

const GoldUpdateArticle = () => {
  const [article, setArticle] = useState(null);
  useEffect(() => {
    const fetchGoldArticle = async () => {
      const { items } = await getGoldArticle();
      if (items && items?.length > 0) {
        setArticle(items[0]);
      }
    };
    fetchGoldArticle();
  }, []);
  return article ? <StoryCard story={article.story} showReadTime={true} showTimestamp={true} /> : null;
};
export default GoldUpdateArticle;
